import { AssignedModuleData, UserInfoEntity } from "../interface/libraryGallery.interface";
import { FileDetails } from "../interface/qualifiedTraders.interface";
import { ActionTypeEntity, ModuleEntity } from "../interface/sign-in";
import { arrowDownKeyCode, arrowLeftKeyCode, arrowRightKeyCode, arrowUpKeyCode, backSpaceKeyCode, copyKeyCode, ctrlKeyCode, cutKeyCode, deleteKeyCode, enterKeyCode, pasteKeyCode, selectAllKeyCode, tabSpacekeyCode, undoKeyCode } from "./constants";
import { StorageKeyEnum } from "./enum";
import { IsNullOrUndefined, IsStringNullEmptyOrUndefined } from "./nullCheck";

export const IsFormValid = (obj: object): boolean => {
  let count = 0;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  Object.entries(obj).forEach(([key, value]) => {
    if (!IsStringNullEmptyOrUndefined(value)) {
      count += 1;
    }
  });

  return count === 0 ? true : false;
};

export const removeSpaceOnFirstCharacter = (event: any): void => {
  if (event.target.selectionStart === 0 && event.code === "Space") {
    event.preventDefault();
  }
};

export const checkValidInputOnKeyDownForNumber = (event: any, regExp: RegExp): void => {
  const key = event.which || event.keyCode;
  const isCtrlOrCmd = event.ctrlKey || event.metaKey;

  const isClipboardAction =
    isCtrlOrCmd &&
    (key === copyKeyCode || key === pasteKeyCode || key === cutKeyCode || key === selectAllKeyCode || key === ctrlKeyCode || key === undoKeyCode);

  const keyChecks =
    key &&
    key !== tabSpacekeyCode &&
    key !== backSpaceKeyCode &&
    key !== deleteKeyCode &&
    key !== enterKeyCode &&
    key !== arrowLeftKeyCode &&
    key !== arrowUpKeyCode &&
    key !== arrowRightKeyCode &&
    key !== arrowDownKeyCode &&
    !isClipboardAction;


  if (!regExp.test(event.key) && keyChecks) {
    event.preventDefault();
  }
};

export const checkValidInputOnKeyDown = (event: any, regExp: RegExp): void => {
  var key = event.which || event.keyCode;

  const keyChecks =
    key &&
    key !== tabSpacekeyCode &&
    key !== backSpaceKeyCode &&
    key !== deleteKeyCode &&
    key !== enterKeyCode &&
    key !== arrowLeftKeyCode &&
    key !== arrowUpKeyCode &&
    key !== arrowRightKeyCode &&
    key !== arrowDownKeyCode;

  if (!regExp.test(event.key) && keyChecks) {
    event.preventDefault();
  }
};

export const getFileFromURL = async (url: string, generateFileName: string): Promise<File> => {
  try {
    console.log('getFileFromURL :: URL :: ', url);

    const response = await fetch(url);
    console.log('getFileFromURL :: respobse :: ', response);

    const blob = await response.blob();
    console.log('getFileFromURL :: BLOB :: ', blob);

    const mimeType = blob.type;
    const extension = mimeType.split("/")[1];
    const fileName = `${generateFileName}.${extension}`;
    return new File([blob], fileName, { type: mimeType });
  } catch (error) {
    console.error("Error in getFileFromURL():", error);
    throw error;
  }
};

export const checkActionAuthorization = (
  action: ActionTypeEntity,
  module: ModuleEntity
) => {
  let index: number = -1;
  const userStr: string | null = sessionStorage.getItem(
    StorageKeyEnum.JB_GLASS_USER_INFO
  );
  if (userStr && !IsStringNullEmptyOrUndefined(userStr)) {
    const userInfo: UserInfoEntity = JSON.parse(userStr);
    const modules: AssignedModuleData[] = userInfo.assignedModule || [];
    index = modules.findIndex(
      (e) => e.action === action && e.moduleName === module
    );
  }
  return index !== -1 ? true : false;
};

export const getThumnailImgFor = (type: "photos" | "albums", url: string): string => {
  const folderToSplit = `/jb-library-${type}/`;
  if (IsStringNullEmptyOrUndefined(url)) {
    return "";
  }
  let arr: string[] = url.split(folderToSplit);
  arr = [
    ...arr.slice(0, 1),
    `/thumbnails${folderToSplit}`,
    ...arr.slice(1)
  ];
  return arr.join("");
};

export const capitalizeFirstLetter = (input: string): string => {
  return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
};

export const checkValidFileExtantion = (fileName: string, fileExtension: string[]): boolean => {
  const extension: string | undefined = fileName.split('.').pop();
  if (extension) {
    return fileExtension.some(ext => extension.includes(ext));
  }
  return false;
}

export const fetchFileDetails = (file: File | null): FileDetails | null => {

  if (IsNullOrUndefined(file)) {
    return null
  }

  const fileName: string = (file as File).name;
  const fileSize: number = (file as File).size;

  // Extract the last extension
  const match = fileName.match(/\.([^.]+)$/);
  const fileType: string = match ? match[1].toLowerCase() : "";

  const displayFileSize: number = parseFloat((fileSize / (1024 * 1024)).toFixed(2));
  return { fileName, fileSize, fileType, displayFileSize }

};